import { render } from "./DetailedProjectFooterList.vue?vue&type=template&id=01918112&scoped=true"
import script from "./DetailedProjectFooterList.vue?vue&type=script&lang=js"
export * from "./DetailedProjectFooterList.vue?vue&type=script&lang=js"

import "./DetailedProjectFooterList.vue?vue&type=style&index=0&id=01918112&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01918112"]])

export default __exports__